import { render, staticRenderFns } from "./RequisicaoDetalhar.vue?vue&type=template&id=34a19eda"
import script from "./RequisicaoDetalhar.vue?vue&type=script&lang=js"
export * from "./RequisicaoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports